import styled from 'styled-components';
import { Grid } from '@elliemae/ds-grid';

var CardContainer = /*#__PURE__*/styled(Grid).withConfig({
  componentId: "sc-1cjakml-0"
})(["align-items:center;justify-content:space-between;width:100%;height:56px;padding:8px 16px;position:relative;border:", ";&:before{content:'';border-bottom:1px solid ", ";position:absolute;margin:0 auto;width:90%;bottom:0;}&:last-child::before{content:none;}"], function (_ref) {
  var theme = _ref.theme,
      hasBorder = _ref.hasBorder;
  return hasBorder ? "1px solid ".concat(theme.colors.neutral['100']) : '';
}, function (props) {
  return props.theme.colors.neutral['100'];
});
var LeftSection = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1cjakml-1"
})(["display:flex;align-items:center;"]);
var LeftAddon = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1cjakml-2"
})(["height:fit-content;width:fit-content;margin-right:16px;cursor:pointer;"]);
var RightAddonSection = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1cjakml-3"
})(["display:flex;align-items:center;width:fit-content;"]);
var RightAddon = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1cjakml-4"
})(["height:fit-content;width:fit-content;cursor:pointer;"]);
var Separator = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1cjakml-5"
})(["width:0px;height:24px;border-right:1px solid ", ";margin:0 8px;"], function (props) {
  return props.theme.colors.neutral['300'];
});
var MainSection = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1cjakml-6"
})(["display:flex;flex-direction:column;"]);
var Title = /*#__PURE__*/styled.h3.withConfig({
  componentId: "sc-1cjakml-7"
})(["margin:0;font-size:16px;font-weight:", ";color:", ";"], function (props) {
  return props.theme.fontWeights.regular;
}, function (props) {
  return props.theme.colors.neutral['800'];
});
var Description = /*#__PURE__*/styled.p.withConfig({
  componentId: "sc-1cjakml-8"
})(["margin:0;color:", ";"], function (props) {
  return props.theme.colors.neutral['600'];
});

export { CardContainer, Description, LeftAddon, LeftSection, MainSection, RightAddon, RightAddonSection, Separator, Title };
//# sourceMappingURL=components.js.map
